/**
 * App shell — router, page metadata, and global chrome.
 * Route trees live in app/AppRoutes.tsx (kept under the 500-line ceiling).
 */

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import CookieConsent from './components/CookieConsent';
import { ToastContainer } from './components/ui/ToastContainer';
import { AccessibilityWidget } from './components/AccessibilityWidget';
import { AppRoutes } from './app/AppRoutes';
import { DocumentTitleSync } from './app/DocumentTitleSync';
import { PageMetaProvider } from './app/pageMeta';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <PageMetaProvider>
          <DocumentTitleSync />
          <AppRoutes />
          <CookieConsent />
          <ToastContainer />
        </PageMetaProvider>
      </BrowserRouter>
      {/* Accessibility widget — outside router so it renders on every page */}
      <AccessibilityWidget />
    </ErrorBoundary>
  );
};

export default App;
